module.exports = {"title":"Available TLDs (Domain Extensions)","header":{"registry":"Registry / Backend","id":"Payload ID","tlds":"TLDs (domain extensions)"}}